<hr class="upperline" />
<div class="my-account-form-container terra-error-style" [formGroup]="formGroup" [class.loading-container-overlay]="isLoading">
  <div class="form-grid">
    <div>
    <p>You need this PIN when you contact Support.</p>
    <p class="lo_sensitive"><b>Current PIN:</b><br/>{{ supportPin }}</p>
    </div>

    <!-- New PIN -->
    <div class="terra-form-field-wrapper full-width">
      <label for="txtNewPin" class="text-input-label">Set a new PIN (should be exactly 4 digits)</label>
      <mat-form-field appearance="outline" class="half-width">
        <input matInput id="txtNewPin" formControlName="supportPin" required minlength="4" maxlength="4" pattern="^\d{4}$" class="lo_sensitive" />
        <mat-error *ngIf="formGroup.get('supportPin').invalid">You must enter a 4 digit value</mat-error>
      </mat-form-field>
    </div>

    <terra-loader class="full-width" *ngIf="isLoading" centerToParent="true"></terra-loader>

    <div class="form-actions full-width">
      <button mat-flat-button color="accent" class="page-cta half-width tall-button" (click)="savePIN()">
        Save
      </button>
    </div>
  </div>
</div>
